import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar17Colors = {
  background?: string;
  skin?: string;
  accessories?: string;
};

export const Avatar17 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar17Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar17">
        <G id="Group 1538228684">
          <Path
            id="background"
            d="M151.833 303.666c83.855 0 151.834-67.978 151.834-151.833S235.688 0 151.833 0 0 67.978 0 151.833s67.978 151.833 151.833 151.833Z"
            fill={c.background}
          />
          <Path
            id="Vector"
            d="M151.833 303.666c34.301 0 65.948-11.383 91.367-30.566-1.279-1.47-2.566-2.773-3.845-3.821-12.4-10.144-50.957-26.278-80.253-31.354-29.304-5.068-68.776.056-80.612 4.568-5.663 2.161-19.85 10.009-33.092 17.603 27.397 26.945 64.97 43.57 106.435 43.57Z"
            fill="#000"
          />
          <G id="Group">
            <G id="Group_2">
              <Path
                id="skin"
                d="M232.897 163.143c2.2-11.947-1.327-17.118-1.327-32.505 5.68-40.393-1.978-80.278-43.372-80.278-74.749 0-82.224 19.907-82.224 66.512 0 2.423-.421 1.525-.19 4.035-11.574 2.645-17.047 15.148-10.796 22.743 12.694 15.418 24.451 25.339 24.792 25.149 2.828 6.442-2.542 46.319-4.416 53.714-3.027 11.931-10.835 16.181-10.835 16.181s40.425 29.654 71.444 26.849c10.335 0 27.969-15.092 6.379-21.836-3.448-1.073-.445-18.684.302-31.449 6.601 1.724 17.777 6.832 27.802-3.559 4.441-10.557 15.554-32.266 22.449-45.556h-.008Z"
                fill={c.skin}
              />
              <Path
                id="Vector_2"
                d="M145.954 117.365s13.028-3.98 23.164-3.909c11.907.08 20.271 7.825 22.559 3.861.731-1.255.231-7.88-21.471-10.049-9.707-.969-15.419 3.456-24.252 10.089v.008Z"
                fill="#000"
              />
              <Path
                id="Vector_3"
                d="M188.333 134.205c-2.939-4.877-7.8-9.365-13.917-10.454-2.756-.317-5.537-.008-8.158.977-2.145.795-3.797 2.113-5.378 3.432-2.152 1.446-5.004.898-7.602.604 2.447 1.66 6.069 2.994 9.04 1.565a26.665 26.665 0 0 1 2.065-1.176 5.75 5.75 0 0 0-.047.627c0 3.877 3.344 7.023 7.475 7.023 4.13 0 7.475-3.146 7.475-7.023a7.29 7.29 0 0 0-.072-.937c2.931 1.303 5.878 3.241 9.111 5.362h.008Z"
                fill="#000"
              />
              <Path
                id="Vector_4"
                opacity={0.75}
                d="M210.488 119.708c-.278-.39-.278-1.033.087-1.788-10.207 14.227 3.892 37.121-1.612 41.442-3.845 3.019-18.366-1.2-18.93 2.661 5.291 3.241 19.851 5.831 24.26-1.668 1.724-3.869-9.691-29.622 1.628-40.655-2.145 1.485-4.488 1.326-5.433.016v-.008Z"
                fill="#2E2017"
              />
              <Path
                id="Vector_5"
                opacity={0.75}
                d="M149.656 212.584c14.33 12.186 22.488 15.888 31.735 16.857-.167-7.142 1.668-17.039 1.263-17.174-20.376-7.006-29.241-13.417-45.779-27.604-6.021-5.163-11.431-12.622-16.094-19.43 0 .453.072.985 0 2.645 2.32 10.057 9.088 27.89 28.875 44.714v-.008Z"
                fill="#2E2017"
              />
              <Path
                id="Vector_6"
                opacity={0.75}
                d="M174.591 175.48c.89.746 13.258 14.417 27.127 13.917 11.812-.421 15.633-11.669 15.911-12.241 0 0-5.219-4.854-8.849-4.719-3.63.135-6.164 1.867-6.164 1.867s-3.265-1.898-7.126-1.763c-3.852.135-7.284 2.097-10.898 2.677-3.646.595-10.009.254-10.009.254l.008.008Zm4.988 2.184c-.095-.047-.007-.159.104-.119 4.416 1.541 12.082 2.59 23.949 2.161 6.117-.223 10.16-.413 13.512-1.486-3.336 1.335-7.736 4.941-13.837 5.164-11.9.429-19.351-3.432-23.728-5.712v-.008Z"
                fill="#2E2017"
              />
              <Path
                id="Vector_7"
                d="M232.945 109.611c-14.235-.413-23.99 7.253-22.457 10.097.946 1.763 3.853 1.834 5.998-.159 5.87-4.894 10.43-3.257 16.586-3.337.135-2.025-.095-4.917-.119-6.601h-.008Z"
                fill="#000"
              />
              <Path
                id="Vector_8"
                d="M238.497 128.827c-1.589-1.319-3.241-2.637-5.378-3.432-2.621-.985-5.402-1.286-8.158-.977-6.109 1.089-10.978 5.585-13.917 10.454 1.66-1.088 3.249-2.129 4.79-3.058.286 3.408 3.32 6.092 7.022 6.092 3.892 0 7.046-2.962 7.046-6.617 0-1.239-.381-2.391-1.017-3.383 2.518.27 5.195 1.223 8.166 3.09 2.971 1.429 6.593.095 9.04-1.565-2.59.294-5.449.842-7.594-.604Z"
                fill="#000"
              />
            </G>
            <G id="Group_3">
              <Path
                id="accessories"
                d="M233.159 113.21s-3.217-36.381-42.324-38.153c-32.806-1.493-69.601 88.619-70.348 96.634-12.114-7.833-14.417-11.773-14.465-12.75-2.574.382-19.39-7.832-22.186-25.348-2.796-17.523 1.676-30.384 1.676-30.384s-4.1-41.195 23.115-61.888c27.215-20.693 58.537-14.727 58.537-14.727s16.594-8.015 33.736.182c17.15 8.206 16.777 16.221 16.777 16.221s7.268-.183 11.002 10.629c3.725 10.81.929 23.489.929 23.489s10.819 19.144 3.551 36.103v-.008Z"
                fill={c.accessories}
              />
              <Path
                id="Vector_9"
                d="m186.141 64.397-15.172 19.445c6.601-5.687 13.329-9.087 19.867-8.785 5.393.246 10.128 1.167 14.274 2.581l-18.969-13.234v-.007Z"
                fill="#000"
              />
              <Path
                id="Vector_10"
                d="M141.959 54.467c-2.566.827-5.132 1.629-7.674 2.495-5.854 2.287-11.899 4.83-17.261 8.102-2.399 1.295-5.736 3.599-7.984 5.195-10.009 7.546-18.977 17.246-23.163 29.217 8.158-18.414 26.873-30.639 45.469-36.716 4.186-1.485 14.664-4.368 14.664-4.368s4.146-12.138 7.141-16.833c3.209-4.973 6.935-9.667 10.962-14.028-8.476 7.078-18.302 16.189-22.154 26.936Z"
                fill="#000"
              />
              <Path
                id="Vector_11"
                d="M229.608 77.107c-8.635-15.22-24.577-26.762-42.268-28.017l12.083-5.33s-93.536 9.651-92.956 96.705c.04 6.172-.612 12.32-.453 18.476 2.804-45.548 15.601-85.123 62.54-100.922 34.451-11.598 51.18 4.718 61.046 19.088h.008Z"
                fill="#000"
              />
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
};
